import { AxiosResponse } from 'axios';
import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import {
  authenticate,
  networkDelay,
  setMockUserAuthToken,
} from '@/test/mocks/utils';

import { UserRegistrationResponse, AuthUser } from '../types';

export type LoginDetails = {
  otpLogin: boolean;
  mobile_number?: string;
  otp?: string;
  email?: string;
  password?: string;
  otp_type?: string;
  source?: string;
};

export const login = (
  data: LoginDetails
): Promise<AxiosResponse<UserRegistrationResponse.Root>> => {
  return axios.post('/user/v1/login', data);
};

export const loginMockHandler = http.post(
  `${env.API_URL}/user/v1/login`,
  async ({ request }): Promise<HttpResponse<UserRegistrationResponse.Root>> => {
    const credentials = (await request.json()) as LoginDetails;
    const result = authenticate(credentials);

    await networkDelay();

    setMockUserAuthToken(result.cookie);

    // Transform the user to match AuthUser type
    const authUser: AuthUser = {
      id: result.user.id,
      email_hash: result.user.email, // Using email as email_hash for mock
      base_lead_id: result.user.base_lead_id,
      consent_granted: true, // Default to true for mock
      practice_id: result.user.practice_id,
      selected_variant_id: null,
    };

    return HttpResponse.json({
      status: 'Success',
      message: 'User logged in',
      user: authUser,
    });
  }
);
